/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule }     from '@angular/core';
import { RouterModule } from '@angular/router';

import {MotoristaListComponent} from "./motorista-list/motorista-list.component";
import {MotoristaFormComponent} from "./motorista-form/motorista-form.component";
import {editRoute, newRoute} from "../../shared/services/data.service";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class MotoristasRoutingModule {}

export const motoristasRoutes: any[] = [
  {
    path: '',
    component: MotoristaListComponent
  },{
    path: editRoute + '/:id',
    component: MotoristaFormComponent
  },{
    path: newRoute,
    component: MotoristaFormComponent
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/motoristas/motoristas-routing.module.ts
 **/